import React from 'react';
import gql from 'graphql-tag';
import { useLazyQuery } from '@apollo/client';
import { FieldSelectDB, FsProps } from 'motion-components';
import { useTranslation } from 'react-i18next';

const gqlGetValues = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntContributorsGroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
      }
      recordCount
    }
  }
`;

const gqlGetValuesEn = gql`
  query getValues($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntContributorsGroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: enName
      }
      recordCount
    }
  }
`;

export function useGetContributorAsOptionsQuery() {
  return useLazyQuery(gqlGetValues);
  //return [null, { loading: null, data: null }];
}

export function useGetContributorAsOptionsQueryEn() {
  return useLazyQuery(gqlGetValuesEn);
  //return [null, { loading: null, data: null }];
}

export const FieldSelectContributorGroups = ({
  label = 'Κατηγορία Υπόχρεου',
  name = 'contributorGroupId',
  defaultValues = {},
  ...rest
}: FsProps) => {
  const { t, i18n } = useTranslation();
  const gr = i18n.language === 'gr';
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      // @ts-ignore
      //sbLabel={defaultValues?.batteriescollectionsState?.name ?? undefined}
      hook={gr ? useGetContributorAsOptionsQuery : useGetContributorAsOptionsQueryEn}
    />
  );
};

